export class AccountingModel {
    uid: string;
    activityUid: string;
    number: string;
    name: string;
    type: string;
    accountGroup: string;
    palabrasClave: string;

    constructor() {
    }
}
